import React from 'react';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import useSubscriptionCheck from '../../common/SubscriptionCheck';
import { useTranslatedMessages } from '../../../hooks/useTranslatedMessages';
import { usePermissions } from '../../../hooks/usePermissions';
import { CREATE_PURCHASE_REGISTER } from '../../../constants/eInvoicePermissions';
import { useAccessDeniedMessage } from '../../../hooks/useAccessDeniedMessage';
import PermissionDeniedWrapper from '../../../components/PermissionDeniedWrapper';

function PurchaseInvoiceRegisterListActions() {
  const navigate = useNavigate();
  const { checkSubscription, SubscriptionModal } = useSubscriptionCheck();
  const { hasEInvoicePermission } = usePermissions();
  const accessDeniedMessage = useAccessDeniedMessage();
  const { purchaseInvoiceRegister } = useTranslatedMessages();
  const canCreate = hasEInvoicePermission(CREATE_PURCHASE_REGISTER);

  const handleCreateAction = () => {
    if (!canCreate || !checkSubscription()) {
      return;
    }
    navigate('/purchase-invoice-register/create');
  };

  return (
    <>
      <PermissionDeniedWrapper show={!canCreate} title={accessDeniedMessage}>
        <Button
          id="create-purchase-invoice-register"
          variant="contained"
          color="primary"
          onClick={handleCreateAction}
          disabled={!canCreate}
        >
          {purchaseInvoiceRegister?.list_actions?.create_entry ?? '+ Add Entry'}
        </Button>
      </PermissionDeniedWrapper>
      <SubscriptionModal />
    </>
  );
}

export default PurchaseInvoiceRegisterListActions;
